module.exports = __webpack_public_path__ + "img/google-play-badge-downloads.17b175b7.svg";